module.exports = __webpack_public_path__ + "static/media/sverige.75971c51.svg";